// ===================================
// UPDATED APP WITH DEDICATED ACTIONS ROUTE - src/App.tsx
// ===================================
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TopicsPage from './pages/TopicsPage';
import ActionsPage from './pages/ActionsPage';
import ProfileSettings from './pages/Profile'; // ADD THIS
import HealthCheck from './components/HealthCheck';
 
function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="topics" element={<TopicsPage />} />
                <Route path="topics/:topicId/actions" element={<ActionsPage />} />
                <Route path="profile" element={<ProfileSettings />} /> {/* ADD THIS */}
                <Route path="health" element={<HealthCheck />} />
              </Route>
              
              {/* Catch all */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;